import React from "react";

import "../blocks/UpcomingShows.css";

import zafarrayaImage from "../images/CarmenSupermarket_Zafarraya.jpg";
import attic from "../images/CarmenSupermarket_Attic.jpeg";
import conciertosotanoclub from "../images/carmensupermarket_sotano.png";
import esGremiLiveImage from "../images/carmensupermarket_sotano_live.jpeg";
import conciertogalileo from "../images/carmensupermarket_galileo_live.png";
import conciertosaranjassa from "../images/CarmenSupermarket_Saranjassa2026.png";
import salaMutanteImage from "../images/CarmenSupermarket_SalaMutante.jpeg";

const shows = [
  {
    id: "salaMutanteOctubre2026",
    dateLabel: "25 OCT 2026",
    venue: "Sala Mutante",
    city: "Palma",
    image: salaMutanteImage,
    alt: "Carmen Supermarket en directo en Sala Mutante, Palma",
    linkUrl: "https://youtu.be/0yHk4sYP4vE",
    isUpcoming: false,
  },
  {
    id: "saranjassamayo2026",
    dateLabel: "16 MAYO 2026",
    venue: "S'Aranjassa",
    city: "Mallorca",
    image: conciertosaranjassa,
    alt: "Carmen Supermarket en directo en S'Aranjassa",
    linkUrl: "https://youtu.be/2JCmMkcfpAg?si=y_fwV-A4pDnvzCZD",
    isUpcoming: false,
  },
  {
    id: "salagalileo2mayo26",
    dateLabel: "2 MAYO 2026",
    venue: "Sala Galileo Galilei",
    city: "Madrid",
    image: conciertogalileo,
    alt: "Carmen Supermarket en directo en Sala Galileo Galilei",
    linkUrl: "https://youtu.be/8L86VaMOGoo?si=hybbWU1-fDc7SjI9",
    isUpcoming: false,
    img_credits: {
      label: "📸 @bedroomeyes_b",
      url: "https://www.instagram.com/bedroomeyes_b/",
    },
  },
  {
    id: "sotanoclubMarzo2026",
    dateLabel: "20 MARZO 2026",
    venue: "Sótano Live",
    city: "Palma de Mallorca",
    image: conciertosotanoclub,
    alt: "Carmen Supermarket en directo en Sótano Live",
    linkUrl: "https://youtu.be/igQICrkeeTE",
    isUpcoming: false,
    img_credits: null,
  },
  {
    id: "esGremi2025salacero",
    dateLabel: "28 NOV 2025",
    venue: "Es Gremi",
    city: "Palma de Mallorca",
    image: esGremiLiveImage,
    alt: "Carmen Supermarket en directo en Es Gremi",
    linkUrl: "https://youtu.be/Ga3bY8QT9cY",
    isUpcoming: false,
    img_credits: null,
  },
  {
    id: "zafarraya2025",
    dateLabel: "25 JUL 2025",
    venue: "Zafarrayasound",
    city: "Granada, España",
    image: zafarrayaImage,
    alt: "Carmen Supermarket en directo en el Festival Zafarraya",
    linkUrl: "https://youtu.be/h-5rR5e480A",
    isUpcoming: false,
    img_credits: null,
  },
  {
    id: "attic2025",
    dateLabel: "14 MARZO 2025",
    venue: "Attic Club",
    city: "Binissalem, Mallorca",
    image: attic,
    alt: "Componentes de Carmen Supermarket en Attic Club",
    linkUrl: "https://youtu.be/Kme8JAnjBJ4",
    isUpcoming: false,
    img_credits: null,
  },
];

const upcomingShows = shows.filter((show) => show.isUpcoming);
const pastShows = shows.filter((show) => !show.isUpcoming);

const ShowCard = ({ show, isFeatured = false }) => {
  const ctaLabel = show.isUpcoming ? "Comprar entradas" : "Ver vídeo";
  const cardModifier = show.isUpcoming
    ? "shows-card--upcoming"
    : "shows-card--past";
  const ctaModifier = show.isUpcoming
    ? "shows-card__cta--upcoming"
    : "shows-card__cta--past";
  const dateModifier = show.isUpcoming ? "" : "shows-card__date--past";
  const tagLabel = show.isUpcoming
    ? "Compra tus entradas"
    : "Revive el directo";
  const featuredModifier = isFeatured ? "shows-card--featured" : "";

  return (
    <article
      key={show.id}
      className={`shows-card ${cardModifier} ${featuredModifier}`.trim()}
    >
      <figure className="shows-card__media">
        <img src={show.image} alt={show.alt} loading="lazy" />
        {show.img_credits && (
          <a
            className="shows-card__credit"
            href={show.img_credits.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {show.img_credits.label}
          </a>
        )}
      </figure>
      <div className="shows-card__content">
        <div className="shows-card__body">
          <div className="shows-card__meta">
            <span
              className={`shows-card__tag shows-card__tag--${
                show.isUpcoming ? "upcoming" : "past"
              }`}
            >
              {tagLabel}
            </span>
            <p className={`shows-card__date ${dateModifier}`.trim()}>
              {show.dateLabel}
            </p>
          </div>
          <h3 className="shows-card__venue">{show.venue}</h3>
          <p className="shows-card__city">{show.city}</p>
        </div>
        <div className="shows-card__cta-panel">
          <a
            className={`shows-card__cta ${ctaModifier}`}
            href={show.linkUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {ctaLabel}
          </a>
        </div>
      </div>
    </article>
  );
};

const UpcomingShows = () => {
  return (
    <section className="shows" id="shows">
      <div className="shows__container">
        <header className="shows__header">
          <p className="shows__eyebrow">Conciertos</p>
          <h2 className="shows__title">
            Vive el directo de Carmen Supermarket
          </h2>
          <p className="shows__intro">
            Descubre cómo sonamos en los shows pasados: ritmos enérgicos,
            guitarras afiladas, teclados envolventes y buen rollo asegurado.
          </p>
        </header>

        <div className="shows__list">
          {upcomingShows.map((show) => (
            <ShowCard key={show.id} show={show} isFeatured />
          ))}

          <div className="shows__archive-grid">
            {pastShows.map((show) => (
              <ShowCard key={show.id} show={show} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingShows;
